import { Button, Col, Container, Row } from "react-bootstrap";
import { CreateNotification } from "../../../../components/notifier";
import { useSelector } from "../../../../store/store";
import { EditorPublicVersion } from "./editor-content-publish-version";
import { EditorFinish } from "./editor-finsh";
import { useSearchParams } from "../../../../hook/use-search-params";
import DocumentView from "./document-view";
import { useUser } from "../../../../hook";
import DecentralizeReviewButton from "./decentralize-review-button";
import { useDocumentInfo } from "../../hooks";

export const Editor = () => {
  const userLogin = useSelector((state) => state.user);
  const { searchParams, replaceSearchParams } = useSearchParams();
  const action = searchParams.get("action");
  const isPublishStatus = searchParams.get("status") === "publish";
  const viewMode = searchParams.get("viewMode") || (isPublishStatus || action === "process" ? "preview" : "edit");
  const { email } = useUser();
  const { data } = useDocumentInfo();

  const setChangedViewMode = (mode: "preview" | "edit" | "decentralize" | "decentralize-preview") => {
    if (data?.docStatusId === 1 && (mode === "decentralize" || mode === "decentralize-preview")) {
      CreateNotification({
        title: "Thông báo",
        body: `Anh/Chị vui lòng vào Tab [Chu trình xử lý] chọn "Bắt đầu soạn thảo" trước khi phân quyền`,
        icon: "/icons/warning.png",
      });
      return;
    }
    searchParams.set("viewMode", mode);
    replaceSearchParams(searchParams);
  };

  return (
    <Container fluid className="document-editor">
      {!isPublishStatus && (
        <div
          id="btn-group-document-action"
          style={{
            display: "flex",
            gap: 10,
            flexDirection: "row-reverse",
            justifyContent: "end",

            marginBottom: 12,
          }}
        >
          {/* {viewMode !== "decentralize" && <Button variant="success">Thêm đoạn</Button>} */}
          <Button variant="info" onClick={() => setChangedViewMode(viewMode === "preview" ? "edit" : "preview")}>
            {viewMode === "preview" ? "Chỉnh sửa" : "Preview"}
          </Button>
          {viewMode !== "decentralize" && data?.userEmail === email?.toLowerCase() && (
            <Button variant="secondary" onClick={() => setChangedViewMode("decentralize")}>
              Phân quyền soạn thảo
            </Button>
          )}
          {(viewMode === "decentralize" || viewMode === "decentralize-preview") && (
            <Button variant="secondary" onClick={() => setChangedViewMode("edit")}>
              Trở về
            </Button>
          )}

          <DecentralizeReviewButton
            viewMode={viewMode}
            document={data}
            onClick={() => setChangedViewMode("decentralize-preview")}
          />
        </div>
      )}
      {isPublishStatus && (
        <>
          <Row className="pb-4">
            <Col sm={12} md={12} style={{ maxHeight: "400px", overflowY: "auto" }}>
              <EditorPublicVersion />
            </Col>
            {/* <Col sm={12} md={12} style={{ maxHeight: "400px", overflowY: "auto", paddingTop: "5px" }}>
              <EditorContentSummary />
            </Col> */}
          </Row>
          <Row>
            <Col sm={12} md={12}>
              <hr style={{ width: "100%" }} />
            </Col>
          </Row>
        </>
      )}
      {data?.docStatusId === 2 && (
        <>
          <Row className="pb-4">
            <Col sm={12} md={12} style={{ maxHeight: "200px", overflowY: "auto" }}>
              <EditorFinish document={data} user={userLogin} />
            </Col>
          </Row>
        </>
      )}

      <div>
        <DocumentView viewMode={viewMode} document={data} />
      </div>
    </Container>
  );
};
